export enum QuotaStatus {
    Open,
    HalfOpen,
    Closed,
}
